import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectOrganizationChartItemOfActiveEmployer = async (
  projectId,
  activeEmployerInfo
) => {
  const apiPath = `organization-charts/project/${projectId}/active-employer-item`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
